import { Select } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { CheckToken } from "../../login/AccessToken";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { ChangeCursor } from "./MiscFunctions";
import { Card, Col, Container, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import { buildConsentRequesterFromDoctor } from "../../../utils/consentRequester";

function GenerateConsent() {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    setError,
    getValues,
    watch,
  } = useForm();
  const [patientIdList, setPatientIdList] = useState([]);
  const [previousConsents, setPreviousConsents] = useState([]);
  const [hipDetails, setHipDetails] = useState([]);
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const REACT_APP_SUFFIX =
    process.env.REACT_APP_IS_ABDM_CONNECTED_WITH_PROD === "true"
      ? process.env.REACT_APP_SUFFIX_PR
      : process.env.REACT_APP_SUFFIX_SB;
  const [consultationType, setConsultationType] = useState([
    { key: "DiagnosticReport", value: "Diagnostic Report" },
    { key: "OPConsultation", value: "OP Consultation" },
    { key: "Prescription", value: "Prescription" },
    { key: "ImmunizationRecord", value: "Immunization Record" },
    { key: "DischargeSummary", value: "Discharge Summary" },
    { key: "HealthDocumentRecord", value: "Health Document Record" },
    { key: "WellnessRecord", value: "Wellness Record" },
  ]);
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  const history = useHistory();
  useEffect(() => {
    if (
      sessionStorage.getItem("accessToken") == undefined &&
      sessionStorage.getItem("accessToken") == null
    ) {
      history.push("/login");
    }
  }, []);

  const abha_id_field = watch("abha_id");
  const patient_id_field = watch("patient_id_list");

  useEffect(() => {
    if (abha_id_field !== undefined && abha_id_field !== null) {
      const patient_id = patientIdList.filter((item, index) => {
        if (item.abha_id === abha_id_field) {
          return item;
        }
      });
      if (patient_id !== undefined && patient_id.length > 0) {
        setValue("patient_id_list", patient_id[0].value);
      }
    }
  }, [abha_id_field]);

  useEffect(() => {
    if (patient_id_field !== undefined && patient_id_field !== null) {
      const abha_id = patientIdList.filter((item, index) => {
        if (item.value === patient_id_field) {
          return item;
        }
      });
      if (abha_id !== undefined && abha_id.length > 0) {
        setValue("abha_id", abha_id[0].abha_id);
      }
    }
  }, [patient_id_field]);

  const Token = () => {
    const check = CheckToken();
    setAuthToken(sessionStorage.getItem("accessToken"));
    return check;
  };

  // useEffect(() => {
  //   if (Token()) {
  //     axios
  //       .get(`${REACT_APP_BACKEND_ROUTE_URL}get_data_transfer_consent_list/`, {
  //         headers: headers,
  //       })
  //       .then((response) => {
  //         // console.log(response.data)
  //         setPreviousConsents(response.data);
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //         toast.error(err);
  //       });

  //     axios
  //       .get(
  //         `${REACT_APP_BACKEND_ROUTE_URL}get_patient_list_with_aabha_info/`,
  //         {
  //           headers: headers,
  //         }
  //       )
  //       .then((response) => {
  //         // console.log(response)
  //         var patientList = [];
  //         response.data.map((item, index) => {
  //           patientList.push({
  //             text: item.patient_id,
  //             value: item.name,
  //             abha_id: item.abha_id,
  //           });
  //         });
  //         // console.log(patientList)
  //         setPatientIdList(patientList);
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //         toast.error(err);
  //       });

  //     // axios.get("https://hlthtek.com/app/api/get_registered_facilities/",
  //     //     {
  //     //         headers: headers,
  //     //     })
  //     //     .then((response) => {
  //     //         setHipDetails(response.data.services)
  //     //     })
  //     //     .catch((err) => {
  //     //         console.log(err)
  //     //     })
  //   }
  // }, [authToken]);

  const fetchConsentDoctor = () => {
    const role = sessionStorage.getItem("roleType");
    const apiUrl =
      role === "doctor"
        ? `${REACT_APP_BACKEND_ROUTE_URL}get_all_doctors/`
        : `${REACT_APP_BACKEND_ROUTE_URL}get_doctors_based_on_facility_user/`;

    return axios
      .get(apiUrl, { headers })
      .then((res) => {
        if (res.data.status !== "Success") {
          return null;
        }
        const doctors = res.data?.data || res.data?.doctor_list || [];
        const doctorId = sessionStorage.getItem("doctor_id");
        return (
          doctors.find((doctor) => doctor.doctor_id === doctorId) ||
          doctors[0] ||
          null
        );
      })
      .catch((err) => {
        console.log(err);
        return null;
      });
  };

  const generateConsent = (data, e) => {
    e.preventDefault();
    //ChangeCursor();
    console.log(data);
    if (Token()) {
      fetchConsentDoctor().then((doctorData) => {
        var post_data = {};
        post_data.consent = {};
        post_data.consent.purpose = {};
        post_data.consent.purpose.text = "Care Management";
        post_data.consent.purpose.code = "CAREMGT";
        post_data.consent.purpose.refUri = "https://manage-dev.hlthtek.com/";
        post_data.consent.patient = {};
        post_data.consent.patient.id = getValues("abha_id");
        post_data.consent.hip = {};
        post_data.consent.hip.id =
          sessionStorage.getItem("facility_name") || "";
        post_data.consent.requester =
          buildConsentRequesterFromDoctor(doctorData);
        // Check if the last 4 characters of healthId do not contain suffix
        if (!post_data.consent.patient.id.endsWith(REACT_APP_SUFFIX)) {
          post_data.consent.patient.id += REACT_APP_SUFFIX;
        }
        post_data.consent.hiTypes = [];

        post_data.consent.hiTypes = getValues("consultation_type");
        post_data.consent.permission = {};
        post_data.consent.permission.accessMode = "VIEW";
        post_data.consent.permission.dateRange = {};
        var toDateVal = new Date(getValues("to_date"));
        var fromDateVal = new Date(getValues("from_date"));
        var ExpiryDate = new Date(getValues("expiry_date"));
        post_data.consent.permission.dateRange.from = fromDateVal.toISOString();
        post_data.consent.permission.dateRange.to = toDateVal.toISOString();
        post_data.consent.permission.dataEraseAt = ExpiryDate.toISOString();
        post_data.consent.permission.frequency = {};
        post_data.consent.permission.frequency.unit = "HOUR";
        post_data.consent.permission.frequency.value = 1;
        post_data.consent.permission.frequency.repeats = 0;

        axios
          .post(
            `${REACT_APP_BACKEND_ROUTE_URL}hiu_consent_init/`,
            JSON.stringify(post_data),
            {
              headers: headers,
            }
          )
          .then((res) => {
            console.log(res.data.request_id);
            toast.success(
              "The request is created. Please grant consent through PHR app."
            );
            //ChangeCursor();
          })
          .catch((err) => {
            console.log(err);
            toast.error(err);
            //ChangeCursor();
          });
      });
    }
  };

  const downloadPDFFile = (item, index) => {
    var blob = b64toBlob(item.data, item.contentType);
    const url = window.URL.createObjectURL(blob, { type: item.contentType });
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `item_${index}.pdf`);
    document.body.appendChild(link);
    link.click();
  };

  var b64toBlob = function (b64Data, contentType, sliceSize) {
    contentType = contentType || "";
    sliceSize = sliceSize || 512;
    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);
      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
  };

  const navigate = (e) => {
    history.push(`/${e.target.id}`);
  };
  return (
    <div>
      <div>
        <h1 style={{ paddingLeft: "30%" }}> Get Consent For Data</h1>
        <Container>
          <Row
            style={{
              marginTop: "2%",
              marginbottom: "2%",
              paddingBottom: "2%",
              width: "125%",
              marginLeft: "-10%",
            }}
          >
            <Col>
              <Card
                onClick={(e) => navigate(e)}
                id="register_patient"
                style={{
                  width: "100%",
                  marginLeft: "-30%",
                  height: "100%",
                  cursor: "pointer",
                }}
              >
                <div style={{ display: "flex" }} id="register_patient">
                  <img
                    id="register_patient"
                    src="/img/success-black-check-mark.svg"
                    alt=""
                  />
                  <h6
                    id="register_patient"
                    style={{ paddingTop: "10%", whiteSpace: "nowrap" }}
                  >
                    Register Patient
                  </h6>
                </div>
              </Card>
            </Col>
            <Col>
              <Card
                onClick={(e) => navigate(e)}
                id="care_context"
                style={{
                  width: "140%",
                  marginLeft: "-35%",
                  height: "100%",
                  cursor: "pointer",
                }}
              >
                <div style={{ display: "flex" }} id="care_context">
                  <img
                    src="/img/success-black-check-mark.svg"
                    id="care_context"
                    alt=""
                  />
                  <h6
                    id="care_context"
                    style={{ paddingTop: "8%", whiteSpace: "nowrap" }}
                  >
                    Create & Link Visit Purpose
                  </h6>
                </div>
              </Card>
            </Col>
            {sessionStorage.getItem("subscriptionType") !== undefined &&
            sessionStorage.getItem("subscriptionType") !== null &&
            sessionStorage
              .getItem("subscription_type")
              .includes("Connector/Adaptor") ? (
              []
            ) : (
              <Col>
                <Card
                  onClick={(e) => navigate(e)}
                  id="upload_report"
                  style={{ width: "100%", height: "100%", cursor: "pointer" }}
                >
                  <div style={{ display: "flex" }} id="upload_report">
                    <img
                      id="upload_report"
                      src="/img/success-black-check-mark.svg"
                      alt=""
                    />
                    <h6
                      id="upload_report"
                      style={{ paddingTop: "10%", whiteSpace: "nowrap" }}
                    >
                      Upload Report
                    </h6>
                  </div>
                </Card>
              </Col>
            )}
            <Col>
              <Card
                onClick={(e) => navigate(e)}
                id="consent"
                style={{ width: "100%", height: "100%", cursor: "pointer" }}
              >
                <div style={{ display: "flex" }} id="consent">
                  <img
                    id="consent"
                    src="/img/success-black-check-mark.svg"
                    alt=""
                  />
                  <h6
                    id="consent"
                    style={{ paddingTop: "10%", whiteSpace: "nowrap" }}
                  >
                    EHR Data Access
                  </h6>
                </div>
              </Card>
            </Col>
            <Col>
              <Card
                onClick={(e) => navigate(e)}
                id="admin_services"
                style={{ width: "100%", height: "100%", cursor: "pointer" }}
              >
                <div style={{ display: "flex" }} id="admin_services">
                  <img
                    id="admin_services"
                    src="/img/success-black-check-mark.svg"
                    alt=""
                  />
                  <h6
                    id="admin_services"
                    style={{ paddingTop: "10%", whiteSpace: "nowrap" }}
                  >
                    Admin Services
                  </h6>
                </div>
              </Card>
            </Col>
            <Col>
              <Card
                onClick={(e) => navigate(e)}
                id="scan_qr"
                style={{ width: "100%", height: "100%", cursor: "pointer" }}
              >
                <div style={{ display: "flex" }} id="scan_qr">
                  <img
                    id="scan_qr"
                    src="/img/success-black-check-mark.svg"
                    alt=""
                  />
                  <h6
                    id="scan_qr"
                    style={{ paddingTop: "10%", whiteSpace: "nowrap" }}
                  >
                    QR
                  </h6>
                </div>
              </Card>
            </Col>
          </Row>
        </Container>
        <div
          className="col-sm-12 col-md-12 col-lg-7"
          style={{ marginLeft: "22%" }}
        >
          <div className="contact-panel mb-50">
            <form
              className="contact-panel__form"
              onSubmit={handleSubmit(generateConsent)}
            >
              <div className="row">
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <label htmlFor="from_date">ABHA Address</label>
                  <div className="form-group">
                    <i className="icon-news form-group-icon"></i>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter ABHA Address"
                      name="abha_id"
                      {...register("abha_id", {
                        required: "ABHA Address is required.",
                        minLength: {
                          value: 4,
                          message: "Minimum Length is 4.",
                        },
                        pattern: {
                          value: /^[a-zA-Z0-9](.*[a-zA-Z0-9]){2,}[a-zA-Z0-9]$/,
                          message:
                            "Alphanumeric characters only. Must be between 8 to 18 characters long. Special characters allowed: dot (.) or underscore (_), which cannot be in the beginning or at the end.",
                        },
                      })}
                    />
                    {errors.abha_id && (
                      <p className="errorMsg">{errors.abha_id.message}</p>
                    )}
                  </div>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <label htmlFor="from_date">Patient ID List</label>
                  <div className="form-group">
                    <i className="icon-user form-group-icon"></i>
                    <select
                      className="form-control"
                      name="patient_id_list"
                      {...register("patient_id_list", {
                        required: "Patient ID is required.",
                      })}
                    >
                      {patientIdList.map((item, index) => (
                        <option value={item.key}>{item.value}</option>
                      ))}
                    </select>
                    {errors.patient_id_list && (
                      <p className="errorMsg">
                        {errors.patient_id_list.message}
                      </p>
                    )}
                  </div>
                </div>
                {/* <div className="col-sm-6 col-md-6 col-lg-6">
                                    <label htmlFor="from_date">Consultation Types</label>
                                    <div className="form-group">
                                        <i className="icon-user form-group-icon" ></i>
                                        <select className="form-control" name='consultation_type'
                                            multiple={true} {...register("consultation_type", {
                                                required: "Consultation type is required.",
                                            })}>
                                            {consultationType !== undefined ?
                                                consultationType.map((item, index) => (
                                                    <option value={item.key}>{item.value}</option>
                                                ))
                                                :
                                                []
                                            }
                                        </select>
                                        {errors.consultation_type && (
                                            <p className="errorMsg">{errors.consultation_type.message}</p>
                                        )}
                                    </div>
                                </div> */}
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <div className="form-group">
                    <label>Consultation Types</label>
                    {consultationType.map((item, index) => (
                      <div class="form-check">
                        <input
                          type="checkbox"
                          class="form-check-input"
                          placeholder="Select Consultation Types"
                          value={item.key}
                          name="health_info_type"
                          {...register("consultation_type", {
                            required: "Consultation Types are required.",
                          })}
                        />
                        <label class="form-check-label" for="flexRadioDefault2">
                          {item.value}
                        </label>
                      </div>
                    ))}
                  </div>
                  {errors.consultation_type && (
                    <p className="errorMsg">
                      {errors.consultation_type.message}
                    </p>
                  )}
                </div>
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <label htmlFor="from_date">From Date</label>
                  <div className="form-group form-group-date">
                    <i className="icon-calendar form-group-icon"></i>
                    <input
                      type="date"
                      className="form-control"
                      id="from_date"
                      placeholder="Enter From Date"
                      name="from_date"
                      {...register("from_date", {
                        required: "From Date is required.",
                      })}
                    />
                    {errors.from_date && (
                      <p className="errorMsg">{errors.from_date.message}</p>
                    )}
                  </div>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <label htmlFor="from_date">To Date</label>
                  <div className="form-group form-group-date">
                    <i className="icon-calendar form-group-icon"></i>
                    <input
                      type="date"
                      className="form-control"
                      placeholder="Enter To Date"
                      name="to_date"
                      {...register("to_date", {
                        required: "To Date is required.",
                      })}
                    />
                    {errors.to_date && (
                      <p className="errorMsg">{errors.to_date.message}</p>
                    )}
                  </div>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <label htmlFor="from_date">Expiry Date</label>
                  <div className="form-group form-group-date">
                    <i className="icon-calendar form-group-icon"></i>
                    <input
                      type="date"
                      className="form-control"
                      placeholder="Enter Expirty Date"
                      labe
                      name="expiry_date"
                      {...register("expiry_date", {
                        required: "Expirty Date is required.",
                      })}
                    />
                    {errors.expiry_date && (
                      <p className="errorMsg">{errors.expiry_date.message}</p>
                    )}
                  </div>
                </div>
                <div className="col-12">
                  <button
                    type="submit"
                    className="btn btn__secondary btn__rounded btn__block btn__xhight mt-10"
                  >
                    <span>Request Health Data</span>{" "}
                    <i className="icon-arrow-right"></i>
                  </button>
                  <div className="contact-result"></div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div>
        <h1>List of Previous Consents</h1>
        {previousConsents !== undefined && previousConsents.length > 0 ? (
          <div>
            {previousConsents !== undefined
              ? previousConsents.map((item, index) => (
                  <div>
                    <Accordion
                      style={{
                        border: "1px solid black",
                        borderWidth: "thin",
                        width: "80%",
                      }}
                    >
                      <AccordionSummary
                        style={{
                          background: "#CFE2FF",
                          border: "1px solid #D3D3D3",
                        }}
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      >
                        <Typography>
                          <b>Patient ID:</b>{" "}
                          {item.consent_details.patient_abha_id} &nbsp; | &nbsp;
                          <b>HI Types</b>: {item.consent_details.hi_types}&nbsp;
                          | &nbsp;
                          <b>Date From</b>: {item.consent_details.date_from}
                          &nbsp; | &nbsp;
                          <b>Date To:</b> {item.consent_details.date_to}&nbsp; |
                          &nbsp;
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Typography>
                          <b>CONSENT STATUS:</b> {item.consent_details.status}{" "}
                          <br />
                          {item.data_received_details !== undefined &&
                          item.data_received_details.length > 0
                            ? item.data_received_details.map((obj, index) => (
                                <>
                                  <b>Consent Artefact 1 :</b> {obj.hip_id}
                                  <br />
                                  <b>Transfer Status :</b> {obj.status}
                                  <br />
                                  <b>Files Received :</b>{" "}
                                  {obj.attachment_list.length > 0 ? (
                                    obj.attachment_list.map((item, index) => (
                                      <>
                                        <p
                                          style={{
                                            cursor: "pointer",
                                            color: "blue",
                                          }}
                                          onClick={() =>
                                            downloadPDFFile(item, index)
                                          }
                                        >
                                          Item {index + 1}
                                        </p>

                                        <br />
                                        <br />
                                      </>
                                    ))
                                  ) : (
                                    <>
                                      EMPTY
                                      <br />
                                      <br />
                                    </>
                                  )}
                                </>
                              ))
                            : []}
                        </Typography>
                      </AccordionDetails>
                    </Accordion>
                  </div>
                ))
              : []}
          </div>
        ) : (
          []
        )}
      </div>
    </div>
  );
}

export default GenerateConsent;
